import Lenis from '@studio-freight/lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import * as Utils from './utils';

export function init(wrapper = false) {
    if (
        window.matchMedia("(max-width: 1024px)").matches ||
        Utils.isMobile()
    ) {
        if (wrapper) {
            disableScroll();
        } else {
            enableScroll();
        }

        return;
    }

    const args = {
        smoothTouch: true,
        syncTouch: true,
        touchMultiplier: 0,
    }

    if (wrapper) {
        args.wrapper = wrapper;
        disableScroll();
    } else {
        enableScroll();
    }

    this.lenis = new Lenis(args);

    this.lenis.on('scroll', ScrollTrigger.update)
    this.lenis.on('resize', ScrollTrigger.update)

    gsap.ticker.add((time)=>{
      this.lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
}

export function destroy() {
    if (
        window.matchMedia("(max-width: 1024px)").matches ||
        Utils.isMobile()
    ) {
        return;
    }
        
    if (!this.lenis) return;

    this.lenis.destroy();
}

export function resize() {
    if (
        window.matchMedia("(max-width: 1024px)").matches ||
        Utils.isMobile()
    ) {
        return;
    }
        
    if (!this.lenis) return;
    this.lenis.resize();
}

export function disableScroll() {
    document.body.style.overflow = "hidden";
}

export function enableScroll() {
    document.body.style.overflow = "auto";
}

